<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLocation_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M12 22s8-6.25 8-12.5C20 5.358 16.418 2 12 2S4 5.358 4 9.5C4 15.75 12 22 12 22m0-10a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
        clip-rule="evenodd"
    />
</svg>
